import Textfield from "../../../common/components/Textfiled.jsx"
import Textarea from "../../../common/components/Textareafield.jsx"
import Select from "../../../common/components/Select.jsx"
import Button from "../../../common/components/Button.jsx"
import FileUploader from "../../../common/components/FileUploader.jsx"

const OPTIONS_TYPES  = [
  {value: "verbal", label: "Verbal"},
  {value: "escrito", label: "Escrito"},
  {value: "grave", label: "Grave"},
]

const OPTIONS_STATUS = [
  {value: "pendiente", label: "Pendiente"},
  {value: "firmado", label: "Firmado"},
  {value: "rechazado", label: "Rechazado"},
  {value: "cerrado", label: "Cerrado"},
]

function FormCallToAttention({callToAttention, onChange, onSubmit, errors, submitLabel, loading}){
const handleSubmit = e => {
e.preventDefault();
e.stopPropagation();
if(onSubmit) onSubmit();
}

  const existingDocument =
    typeof callToAttention.document === "string"
      ? callToAttention.document
      : null;

  return (
    
<form onSubmit={handleSubmit} className="container mt-4">
  <div className="row mb-3">
    <div className="col-md-6">
      <Textfield
        label="Nombre del llamado de atención"
        placeholder="Nombre del llamado de atención"
        name="nameCautioned"
        value={callToAttention.nameCautioned}
        onChange={onChange}
        error={errors.nameCautioned}
        className={`form-control ${errors.nameCautioned ? 'is-invalid' : ''}`}
      />
      {errors.nameCautioned && (
        <div className="invalid-feedback">{errors.nameCautioned}</div>
      )}
    </div>

    <div className="col-md-6">
      <Textfield
        label="Identificación del llamado de atención"
        placeholder="Identificación del llamado de atención"
        name="identificationCautioned"
        value={callToAttention.identificationCautioned}
        onChange={onChange}
        error={errors.identificationCautioned}
        className={`form-control ${errors.identificationCautioned ? 'is-invalid' : ''}`}
      />
      {errors.identificationCautioned && (
        <div className="invalid-feedback">{errors.identificationCautioned}</div>
      )}
    </div>
  </div>

  <div className="row mb-3">
    <div className="col-md-6">
      <Select
        label="Tipo de llamado de atención"
        name="type"
        value={callToAttention.type}
        onChange={onChange}
        options={OPTIONS_TYPES}
        error={errors.type}
        className={`form-select ${errors.type ? 'is-invalid' : ''}`}
      />
      {errors.type && (
        <div className="invalid-feedback">{errors.type}</div>
      )}
    </div>

    <div className="col-md-6">
      <Textarea
        label="Motivo del llamado de atención"
        placeholder="Motivo del llamado de atención"
        name="reason"
        value={callToAttention.reason}
        onChange={onChange}
        error={errors.reason}
        className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
      />
      {errors.reason && (
        <div className="invalid-feedback">{errors.reason}</div>
      )}
    </div>
  </div>

  <div className="row mb-3">
    <div className="col-md-6">
      <Textfield
        label="Nombre del responsable"
        placeholder="Nombre del responsable"
        name="nameResponsible"
        value={callToAttention.nameResponsible}
        onChange={onChange}
        error={errors.nameResponsible}
        className={`form-control ${errors.nameResponsible ? 'is-invalid' : ''}`}
      />
      {errors.nameResponsible && (
        <div className="invalid-feedback">{errors.nameResponsible}</div>
      )}
    </div>

    <div className="col-md-6">
      <Textfield
        label="Fecha del llamado de atención"
        name="date"
        type="date"
        value={callToAttention.date}
        onChange={onChange}
        error={errors.date}
      />
    </div>
  </div>

  <div className="row mb-3">
    <div className="col-md-6">
      <Select
        label="Estado del llamado de atención"
        name="status"
        value={callToAttention.status}
        onChange={onChange}
        options={OPTIONS_STATUS}
        error={errors.status}
        className={`form-select ${errors.status ? 'is-invalid' : ''}`}
      />
      {errors.status && (
        <div className="invalid-feedback">{errors.status}</div>
      )}
    </div>

    <div className="col-md-6">
      <Textarea
        label="Observaciones"
        placeholder="Observaciones"
        name="observations"
        value={callToAttention.observations || ""}
        onChange={onChange}
        error={errors.observations}
      />
      {errors.observations && (
        <div className="invalid-feedback">{errors.observations}</div>
      )}
    </div>
  </div>

  <div className="row mb-3">
    <div className="col-12">
      <label className="form-label">Documento PDF (opcional)</label>
      {existingDocument && !callToAttention.file && (
        <p className="mb-2">
          <a href={existingDocument} target="_blank" rel="noopener noreferrer">
            Ver PDF actual
          </a>
        </p>
      )}
      <FileUploader
        accept="application/pdf"
        value={callToAttention.file}
        onFileChange={(file) => onChange({ name: "file", value: file })}
        error={errors.file}
      />
      {errors.file && (
        <div className="text-danger small mt-1">{errors.file}</div>
      )}
    </div>
  </div>

  <div className="text-center">
    <Button type="submit" className="btn btn-primary" disabled={loading}>
      {submitLabel || "Crear llamado de atención"}
    </Button>
  </div>
</form>
  );
}

export default FormCallToAttention;
